import '../../external/jquery.ui.touch-punch.min';
import { sliderOptionFormat } from './search_slider_format';

export const searchPriceSlider = {
    sliderName: '',
    fromElement: '',
    toElement: '',
    minimumValue: 1,
    maximumValue: 500000,
    sliderOptionsCount: 0,
    sliderStepWidth: 0,
    sliderMaximum: 580, // keep this value multiply of length of list, i.e. this.sliderOptionsCount * 10
    list: [],
    generateList() {
        this.list = [
            this.minimumValue,
            100,
            200,
            300,
            400,
            500,
            600,
            700,
            800,
            900,
            1000,
            2000,
            3000,
            4000,
            5000,
            6000,
            7000,
            8000,
            9000,
            10000,
            11000,
            12000,
            13000,
            14000,
            15000,
            16000,
            17000,
            18000,
            19000,
            20000,
            21000,
            22000,
            23000,
            24000,
            25000,
            30000,
            35000,
            40000,
            45000,
            50000,
            55000,
            60000,
            65000,
            70000,
            75000,
            80000,
            85000,
            90000,
            95000,
            100000,
            150000,
            200000,
            250000,
            300000,
            350000,
            400000,
            450000,
            this.maximumValue,
        ];
        this.sliderOptionsCount = this.list.length;
        this.sliderStepWidth = this.sliderMaximum / this.sliderOptionsCount;
    },
    init(optionsInput) {
        const options = optionsInput || {};
        this.sliderName = options.sliderName ? options.sliderName : $('#simple_search #priceSlider');
        this.fromElement = options.fromElement ? options.fromElement : $('#simple_search #priceFrom');
        this.toElement = options.toElement ? options.toElement : $('#simple_search #priceTo');
        this.generateList();

        this.sliderName.slider({
            animate: true,
            range: true,
            min: 0,
            max: this.sliderMaximum,
            create() {
                searchPriceSlider.setSlider(searchPriceSlider.fromElement.val(), searchPriceSlider.toElement.val());
                searchPriceSlider.sliderFormat();
            },
            slide(event, ui) {
                if (ui.handle.nextSibling) {
                    let minValIndex = sliderOptionFormat.getSliderIndex(
                        ui.values[0],
                        searchPriceSlider.sliderOptionsCount,
                        searchPriceSlider.sliderStepWidth
                    );
                    searchPriceSlider.fromElement.val(searchPriceSlider.list[minValIndex]);
                } else {
                    let maxValIndex = sliderOptionFormat.getSliderIndex(
                        ui.values[1],
                        searchPriceSlider.sliderOptionsCount,
                        searchPriceSlider.sliderStepWidth
                    );
                    searchPriceSlider.toElement.val(searchPriceSlider.list[maxValIndex]);
                }
                searchPriceSlider.sliderFormat();
            },
            stop() {
                searchPriceSlider.fromElement.trigger('change');
            },
        });

        // Disable tabbing on slider handles
        this.sliderName.find('.ui-slider-handle').attr('tabindex', '-1');
    },
    setSlider(fromValueInput, toValueInput) {
        let fromIndex = 0,
            toIndex = searchPriceSlider.sliderMaximum;

        let fromValue = parseInt(fromValueInput, 10);
        let toValue = parseInt(toValueInput, 10);
        if (fromValue > 0) {
            fromValue = sliderOptionFormat.getClosestOption(searchPriceSlider.list, fromValue);
            fromIndex = $.inArray(parseInt(fromValue, 10), searchPriceSlider.list) * searchPriceSlider.sliderStepWidth;
        }

        if (toValue > 0) {
            toValue = sliderOptionFormat.getClosestOption(searchPriceSlider.list, toValue);
            toIndex = $.inArray(parseInt(toValue, 10), searchPriceSlider.list) * searchPriceSlider.sliderStepWidth;
        }

        searchPriceSlider.sliderName.slider('values', [fromIndex, toIndex]);
    },
    sliderFormat() {
        sliderOptionFormat.setRangeSlider(
            searchPriceSlider.fromElement,
            searchPriceSlider.toElement,
            searchPriceSlider.minimumValue,
            searchPriceSlider.maximumValue,
            'priceRange',
            '€',
            true
        );
    },
};
